import React, { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from './../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from './../../../Auth/AuthContext';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';

export default function Categorias(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [nombreComponente, setNombreComponente] = useState('Categorías');
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
                <div>
                    <div className="btn-group">
                        <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                            data-tooltip-id='tooltiparriba'
                            data-tooltip-content="Editar">
                            <FaArrowAltCircleRight/>
                        </button>
                    </div>
                </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, filterable: true },
        { name: 'Categoría', selector: row => row.categoria, sortable: true },
        { name: 'Activo', selector: row => (row.activo ? 'Sí' : 'No'), sortable: true },
    ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/diagnostico/consultarcategoriasdx';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result.data);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setValue('Nuevo', false);
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('categoria', row.categoria);
        setValue('activo', row.activo);
    }
    const Nuevo = () =>  {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('categoria', '');
        setValue('activo', true);
        setMuestraFormulario(1);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/diagnostico/guardarcategoriasdx';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));    
                fetchData();            
                ResetForm();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('Nuevo', true);
        setValue('id', 0);
        setValue('categoria', '');
        setValue('activo', true);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title={nombreComponente}
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parámetros"
                nombreform={nombreComponente}
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario {nombreComponente}</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <div className="row">
                                        <input hidden {...register('id')}/>
                                        <input hidden {...register('Nuevo')}/>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="categoria">Categor&iacute;a</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.categoria ? 'is-invalid' : ''}`}
                                                    id="categoria"
                                                    {...register('categoria', { 
                                                        maxLength: { value: 300, message: 'Máximo 300 caracteres' },
                                                        required: 'Este campo es obligatorio'
                                                    })}
                                                />
                                                {errors.categoria && <div className="invalid-feedback">{errors.categoria.message}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="activo">Activo</label>
                                                <select
                                                    className={`form-control ${errors.activo ? 'is-invalid' : ''}`}
                                                    id="activo"
                                                    {...register('activo', { required: 'Este campo es obligatorio' })}
                                                >
                                                    <option value={true}>S&iacute;</option>
                                                    <option value={false}>No</option>
                                                </select>
                                                {errors.activo && <div className="invalid-feedback">{errors.activo.message}</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                <DataTable
                                    title={`Lista de ${nombreComponente}`}
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}